import {Injectable, Pipe, PipeTransform} from '@angular/core';
import {CompetitorStageDetail, FINISH_CONTROL_POINT_TYPE, Waypoint} from '@model';
import {getLanguageValue} from "@utility";
import {TranslocoService} from "@ngneat/transloco";

@Injectable({providedIn: 'root'})
@Pipe({name: 'waypointNameByWaypointId'})
export class WaypointNameByWaypointIdPipe implements PipeTransform {

  constructor(private translocoService: TranslocoService) {
  }

  transform(competitorStageDetail?: CompetitorStageDetail): string {
    if (!competitorStageDetail) {
      return '';
    }

    if (competitorStageDetail.nm) {
      return competitorStageDetail.nm;
    }

    if (competitorStageDetail.tp === FINISH_CONTROL_POINT_TYPE) {
      return this.translocoService.translate('organiser.event.details.control.point.waypointType.4');
    }

    return getLanguageValue(competitorStageDetail.pointNameHr, competitorStageDetail.pointNameEn, competitorStageDetail.pointNameIt, competitorStageDetail.pointNameSlo, competitorStageDetail.pointNameSr, competitorStageDetail.pointNameBs, this.translocoService.getActiveLang()) ?? "";
  }
}
